var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"mb-5 mx-5",attrs:{"color":"primary","dark":"","rounded":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(" السابق "),_c('v-icon',[_vm._v("mdi-arrow-right")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }